import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// content loaded
document.addEventListener('DOMContentLoaded', () => {

    // Default Slider
    const swiper = new Swiper('.swiper-default', {
        // Loop the slides
        loop: true,
        // Transition speed
        speed: 500,
        // Autoplay settings
        autoplay: {
            delay: 1000,
            disableOnInteraction: false,
        },
        // Disable/Enable draggable
        simulateTouch: true,
        // Spacing between slides
        spaceBetween: 30,
        // Slides per view
        slidesPerView: 2,
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // Continuous Slider
    const swiperContinuous = new Swiper('.swiper-continous', {
        // Loop the slides
        loop: true,
        // Transition speed
        speed: 1500,
        // Autoplay settings
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        // Disable/Enable draggable
        simulateTouch: true,
        // Spacing between slides
        spaceBetween: 30,
        // Slides per view
        slidesPerView: 2,
    });

    const insightsSwipers = document.querySelectorAll('.swiper-insights');
    insightsSwipers.forEach((el) => {
        const colCount = parseInt(el.dataset.colCount, 10) || 4;
        // Auto-calculate breakpoint slides based on colCount
        const slidesAt992 = colCount;                          // 4, 3, or 2
        const slidesAt768 = Math.ceil(colCount / 2) + 0.1;   // 4→2.1 | 3→2.1 | 2→1.1
        const slidesDefault = 1.1;
        new Swiper(el, {
            loop: false,
            speed: 500,
            simulateTouch: true,
            spaceBetween: 20,
            slidesPerView: slidesDefault,
            breakpoints: {
                768: {
                    slidesPerView: slidesAt768,
                },
                992: {
                    slidesPerView: slidesAt992,
                },
            },
        });
    });

    const testimonialSlider = new Swiper('.swiper-testimonials', {
        loop: false,
        speed: 500,
        simulateTouch: true,
        width: 420,
        slidesPerView: 1.3,
        spaceBetween: 16,
        breakpoints: {
            768: {
                width: null,
                slidesPerView: 2.3,
            },
            992: {
                width: null,
                slidesPerView: 3,
            },
        },
    });

    const quickLinks = new Swiper('.swiper-quicklinks', {
        loop: false,
        speed: 500,
        simulateTouch: true,
        width: 301,
        slidesPerView: 2.1,
        spaceBetween: 16,
        breakpoints: {
            768: {
                width: null,
                slidesPerView: 4.2,
                spaceBetween: 20,
            },
            992: {
                width: null,
                slidesPerView: 4.4,
                spaceBetween: 40,
            },
            1400: {
                width: null,
                slidesPerView: 5,
                spaceBetween: 40,
            },
        },
    });

    const featuredProducts = document.querySelector('.swiper-featured-products');
    if ( featuredProducts ) {
        new Swiper(featuredProducts, {
            loop: false,
            speed: 500,
            simulateTouch: true,
            width: 342.1,
            slidesPerView: 1.1,
            spaceBetween: 20,
            breakpoints: {
                768: {
                    width: null,
                    slidesPerView: 3.2,
                    spaceBetween: 30,
                },
                992: {
                    width: 1630,
                    slidesPerView: 4.5,
                    spaceBetween: 48,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    // Location Slider
    const locationSliderEl = document.querySelector('.swiper-location-slider');
    if ( locationSliderEl ) {
        new Swiper(locationSliderEl, {
            loop: false,
            speed: 500,
            simulateTouch: true,
            slidesPerView: 1.2,
            spaceBetween: 16,
            breakpoints: {
                576: {
                    slidesPerView: 2.2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3.2,
                    spaceBetween: 24,
                },
                1200: {
                    slidesPerView: 4.3,
                    spaceBetween: 32,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    const productMenu = new Swiper('.swiper-menu', {
        // Loop the slides
        loop: false,
        // Transition speed
        speed: 500,
        // Autoplay settings
        // autoplay: {
        //     delay: 1000,
        //     disableOnInteraction: false,
        // },
        // Disable/Enable draggable
        simulateTouch: true,
        // Spacing between slides
        spaceBetween: 16,
        // Slides per view
        slidesPerView: 3.1,
        // If we need pagination
        // pagination: {
            //     el: '.swiper-pagination',
            //     clickable: true,
            // },
        breakpoints: {
            768: {
                slidesPerView: 5.1,
                spaceBetween: 32,
            },
            992: {
                slidesPerView: 7,
                spaceBetween: 32,
            },
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // Product Detail Gallery – Thumbs + Main
    const thumbsEl = document.querySelector('.swiper-product-thumbs');
    const mainEl   = document.querySelector('.swiper-product-main');
    if ( thumbsEl && mainEl ) {
        const productThumbs = new Swiper(thumbsEl, {
            spaceBetween: 16,
            slidesPerView: 'auto',
            watchSlidesProgress: true,
        });
        const productMain = new Swiper(mainEl, {
            spaceBetween: 0,
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-product-main .swiper-button-next',
                prevEl: '.swiper-product-main .swiper-button-prev',
            },
            thumbs: {
                swiper: productThumbs,
            },
        });
    } else if ( mainEl ) {
        // Single image – no thumbs needed
        new Swiper(mainEl, {
            spaceBetween: 0,
            slidesPerView: 1,
            allowTouchMove: false,
            navigation: {
                nextEl: '.swiper-product-main .swiper-button-next',
                prevEl: '.swiper-product-main .swiper-button-prev',
            },
        });
    }

    // Tab Packages Slider
    function initTabPackageSwipers() {
        document.querySelectorAll('.swiper-tab-packages').forEach((el) => {
            if (!el.swiper) {
                new Swiper(el, {
                    loop: false,
                    speed: 500,
                    simulateTouch: true,
                    slidesPerView: 1.15,
                    spaceBetween: 16,
                    breakpoints: {
                        576: {
                            slidesPerView: 1.5,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2.2,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 32,
                            simulateTouch: false,
                            allowTouchMove: false,
                        },
                    },
                });
            }
        });
    }
    initTabPackageSwipers();

    // Re-init swipers when a Bootstrap tab is shown (hidden tabs have 0 width)
    document.querySelectorAll('[data-bs-toggle="pill"]').forEach((tabEl) => {
        tabEl.addEventListener('shown.bs.tab', () => {
            initTabPackageSwipers();
        });
    });

    // Banner Slider
    const bannerEl = document.querySelector('.swiper-banner');
    if (bannerEl) {
        new Swiper(bannerEl, {
            loop: true,
            speed: 800,
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
            },
            simulateTouch: true,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
        });
    }
});
